import Phaser from 'phaser';
import { threeDigitsNumber } from '../../utils';

export default class Player extends Phaser.Physics.Arcade.Sprite {
  constructor({ scene, x, y }) {
    super(scene, x, y, `player_0_idle`);
    
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.body.setSize(250, 300);
    this.body.setCollideWorldBounds(true);

    createPlayerAnimations.call(scene);

    this.play('player_idle');
  }

  move({ direction = 'right', speed = 200 } = {}) {
    const factor = direction === 'right' ? 1 : -1;
    this.setFlipX(direction !== 'right');
    this.setVelocityX(factor * speed);
  }

  stop() {
    this.setVelocity(0, 0);
  }
}

export function preload() {
  for (let i = 0; i <= 11; i++) {
    this.load.image(`player_${i}_idle`, `Player/Wraith_01_Idle_${threeDigitsNumber(i)}.png`);
  }
}

export function createPlayerAnimations() {
  const scene = this;

  scene.anims.create({
    key: `player_idle`,
    frames: Array(11)
      .fill()
      .map((x, i) => ({
        key: `player_${i}_idle`,
      })),
    frameRate: 16,
    repeat: -1,
  });
}